module.exports = __webpack_public_path__ + "static/media/300.536a958f.png";